import { useQuery } from '@tanstack/react-query';
import { getIntervalFromDateRange } from 'pages/admin/CostDashboard/helper';
import { bff } from 'shared/api';
import {
  BusinessCostSummaryReply,
  BusinessCostSummaryRequest,
} from 'shared/types/protoc-gen/bffbillsystem';
import { QUERY_KEYS } from 'shared/types/react-query';

export type BusinessCostSummaryFilter = Omit<BusinessCostSummaryRequest, 'interval'>;

const useGetBusinessCostSummary = (params: BusinessCostSummaryFilter) => {
  return useQuery<BusinessCostSummaryReply>({
    queryKey: [
      QUERY_KEYS.ADMIN_BUSINESS_COST_SUMMARY,
      params.startTime,
      params.endTime,
      params.namespace,
      params.business,
      params.kind,
      params.type,
      params.subResource,
    ],
    queryFn: async () => {
      const namespace = params.namespace !== 'ALL' ? params.namespace : '';
      const subResource = params.subResource !== 'ALL' ? params.subResource : '';
      const kind = params.kind !== 'ALL' ? params.kind : '';
      const type = params.type !== 'ALL' ? params.type : '';

      const payload = {
        ...params,
        namespace,
        interval: getIntervalFromDateRange(params.startTime, params.endTime),
        subResource,
        kind,
        type,
      };

      const res = await bff.get<BusinessCostSummaryReply>('/bff/cost/business_summary', {
        params: payload,
      });

      return res.data;
    },
  });
};

export default useGetBusinessCostSummary;
